import { useResourceTree } from './use-resource-tree';

/**
 * ViewModel for the Agents detail file browser. Thin wrapper around the
 * generic `useResourceTree` — defaults to `AGENT.md` as the first selection.
 */
export function useAgentTree(
  agentId: string | null,
  ref: string | null,
  options: { enabled?: boolean } = {},
) {
  return useResourceTree('agent', agentId, ref, { ...options, defaultFile: 'AGENT.md' });
}
